import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import Homepage from "pages/homepage";
import ServiceEcosystem from "pages/service-ecosystem";
import DiscoveryPortal from "pages/discovery-portal";
import ProductsPortfolio from "pages/products-portfolio";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/service-ecosystem" element={<ServiceEcosystem />} />
        <Route path="/discovery-portal" element={<DiscoveryPortal />} />
        <Route path="/products-portfolio" element={<ProductsPortfolio />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;